import React, { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import SuccessAlert from "../child/Alert/SuccessAlert";
import DengerAlert from "../child/Alert/DengerAlert";
import Loader from "../child/Loder";
import { getPromoterPayoutDetail } from "../../services/promoterPayoutService";
import PayoutTransactionsTable, {
  formatPayoutAmount,
  formatPayoutDate,
} from "./PayoutTransactionsTable";

const ViewPromoterPayoutPageNew = () => {
  const { id } = useParams();
  const location = useLocation();
  const [itemData, setItemData] = useState(location.state?.payout || null);
  const [loading, setLoading] = useState(true);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const getDisplayStatus = (item) => {
    const raw = String(
      item?.transactionStatus || item?.status || "",
    ).toLowerCase();
    if (
      raw === "paid" ||
      raw === "completed" ||
      raw === "success"
    ) {
      return "Paid";
    }
    return "Pending";
  };

  useEffect(() => {
    const fetchData = async () => {
      if (!id) {
        setLoading(false);
        return;
      }
      setLoading(true);
      try {
        const res = await getPromoterPayoutDetail(id);
        const payload = res?.data || {};
        const data = payload.data || payload.result || payload.payout || payload;
        if (data && (data._id || data.promoterName || data.amount != null)) {
          setItemData(data);
        }
      } catch (err) {
        if (!location.state?.payout) {
          setErrorMessage(
            err?.response?.data?.message ||
              "Failed to fetch promoter payout detail.",
          );
        }
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  if (loading && !itemData) return <Loader />;

  return (
    <div className="row gy-4">
      {successMessage && (
        <SuccessAlert
          message={successMessage}
          onClose={() => setSuccessMessage("")}
        />
      )}
      {errorMessage && (
        <DengerAlert
          message={errorMessage}
          onClose={() => setErrorMessage("")}
        />
      )}

      <div className="col-md-12">
        <div className="card h-100">
          <div className="card-body p-24">
            <div className="row">
              <div className="col-md-3 mb-3">
                <label className="form-label fw-bold">Promoter Name</label>
                <div>{itemData?.promoterName || "N/A"}</div>
              </div>
              <div className="col-md-3 mb-3">
                <label className="form-label fw-bold">Promoter Email</label>
                <div>{itemData?.promoterEmail || "N/A"}</div>
              </div>
              <div className="col-md-3 mb-3">
                <label className="form-label fw-bold">Amount</label>
                <div>
                  {formatPayoutAmount(itemData?.amount, itemData?.currency)}
                </div>
              </div>
              <div className="col-md-3 mb-3">
                <label className="form-label fw-bold">Transaction Status</label>
                <div>{getDisplayStatus(itemData)}</div>
              </div>
              <div className="col-md-3 mb-3">
                <label className="form-label fw-bold">Transaction ID</label>
                <div>{itemData?.referenceId || "N/A"}</div>
              </div>
              <div className="col-md-3 mb-3">
                <label className="form-label fw-bold">Stripe Account ID</label>
                <div>{itemData?.stripeAccountId || "N/A"}</div>
              </div>
              <div className="col-md-3 mb-3">
                <label className="form-label fw-bold">Start Date</label>
                <div>{formatPayoutDate(itemData?.fromDate)}</div>
              </div>
              <div className="col-md-3 mb-3">
                <label className="form-label fw-bold">End Date</label>
                <div>{formatPayoutDate(itemData?.toDate)}</div>
              </div>
              <div className="col-md-3 mb-3">
                <label className="form-label fw-bold">Type</label>
                <div>{itemData?.type || "N/A"}</div>
              </div>
              <div className="col-md-3 mb-3">
                <label className="form-label fw-bold">Created At</label>
                <div>{formatPayoutDate(itemData?.createdAt)}</div>
              </div>
              <div className="col-md-3 mb-3">
                <label className="form-label fw-bold">Payment Count</label>
                <div>{itemData?.paymentCount ?? "N/A"}</div>
              </div>
              <div className="col-md-3 mb-3">
                <label className="form-label fw-bold">
                  Total Transaction Amount
                </label>
                <div>
                  {formatPayoutAmount(
                    itemData?.totalTransactionAmount ?? itemData?.amount,
                    itemData?.currency,
                  )}
                </div>
              </div>
              {/* <div className="col-md-6 mb-3">
                <label className="form-label fw-bold">Description</label>
                <div>{itemData?.description || "N/A"}</div>
              </div> */}
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-12">
        <PayoutTransactionsTable
          transactions={itemData?.transactions || []}
          fromDate={itemData?.fromDate}
          toDate={itemData?.toDate}
          currency={itemData?.currency}
        />
      </div>
    </div>
  );
};

export default ViewPromoterPayoutPageNew;
